import React from "react";
import styled from "styled-components";
import { screen, mainViolet } from "../common/variables";
import { Link } from "gatsby";

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);

  .links {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    @media ${screen.xsmall} {
      padding: 0 25px 0 25px;
    }
    @media ${screen.medium} {
      padding: 0;
    }
    a {
      color: #fff;
      font-size: 0.8rem;
      font-weight: 700;
      border-bottom: 1.5px #fff solid;
      padding: 0 0 2px 0;
      @media ${screen.withCursor} {
        &:hover {
          border-bottom: 1.5px ${mainViolet} solid;
          color: ${mainViolet};
        }
      }
    }
  }
`;

const BottomNav = ({ leftLabel, leftLink, rightLabel, rightLink }) => {
  return (
    <Wrapper>
      <div className="links">
        <Link to={leftLink || "/"}>{leftLabel || "LABEL"}</Link>
        <Link to={rightLink || "/"}>{rightLabel || "LABEL"}</Link>
      </div>
    </Wrapper>
  );
};

export default BottomNav;
